export default __webpack_public_path__ + "static/media/eye-solid.1c7d312e.svg";